module.exports = __webpack_public_path__ + "85b9764054cf9ec7316f65350ee368f0.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update/2021-07-26/whats-new.html
// module id = 2243
// module chunks = 0